<template>
  <div id="app">
    <!-- 主体 -->
    <div class="app-main">
      <keep-alive :exclude="excludeName">
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
      <mu-back-top :height="100" :bottom="80" :right="30" :duration="1000" v-if="!($route.meta.ignoreBackTop === true)"></mu-back-top>
    </div> 
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('keepAlive', [ 'excludeName' ])
  }
}
</script>
<style>
body {
  font-size: 12px
}
.app-main {
  height: 100%;
}
.mu-back-up .mu-back-up-default {
  border-radius: 100px;
  background-color: rgba(255, 255, 255, 0.8);
  box-shadow: 0 1px 6px rgba(0, 0, 0,.4);
}
.mu-back-up i.mu-icon {
  color: #333;
  padding: 10px
}
</style>



// WEBPACK FOOTER //
// src/App.vue